import React from 'react';
import './App.css';
import {pianoBank} from './notesBank.js'
import Note from './Note.jsx'
import SharpNote from './SharpNote.jsx'
import Command from './Command.jsx'
import Fullscreen from 'react-full-screen'


export default class App extends React.Component {
  constructor (props){
    super(props);
    this.state = {
        powerBtn : false,
        volume : 1,
        notesBank : pianoBank,
        currentNote : "",
        currentBank : "Piano",
        isFull : false
    }
    this.handlePower = this.handlePower.bind(this);
    this.handleVolume = this.handleVolume.bind(this);
    this.handleDisplay = this.handleDisplay.bind(this);
    this.handleBank = this.handleBank.bind(this);
    this.goFull = this.goFull.bind(this);
  }

handlePower(){
    this.setState( state => ({
      powerBtn: !state.powerBtn
    }))
  }

  handleVolume(event){
    this.setState({
      volume: event.target.value
    })
  }

  handleBank(bank, name){
    this.setState({
      notesBank: bank,
      currentBank: name
    })
  }

  handleDisplay(note){
    this.setState({
      currentNote: note
    })
  }
  goFull = () => {
    this.setState(state=>({ isFull: !state.isFull }));
  }
  render (){
    
    return (
      <Fullscreen
      enabled={this.state.isFull}
      onChange={isFull => this.setState({isFull})}
    >
      <div className="App">
     
       <Command goFull={this.goFull} currentBank = {this.state.currentBank} currentNote = {this.state.currentNote} handleBank = {this.handleBank} handleVolume = {this.handleVolume} powerBtn = {this.state.powerBtn} handlePower={this.handlePower}/>
       <div className="keyboard">
        <div className="blackwhite">
          <Note  handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"Z"} keycode={90} note={this.state.notesBank[0]} name={"C"} classnameDown ="_whitekey-down" classnameUp="_whitekey-up" />
          <SharpNote handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"S"} keycode={83} note={this.state.notesBank[1]} name={"C#"} classnameDown="blackkey-down" classnameUp="blackkey-up"/>
        </div>  
        <div className="blackwhite">
          <Note handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"X"} keycode={88} note={this.state.notesBank[2]} name={"D"} classnameDown ="_whitekey-down" classnameUp="_whitekey-up" />
          <SharpNote handleDisplay = {this.handleDisplay} volume = {this.state.volume}  powerBtn = {this.state.powerBtn} keyb={"D"} keycode={68} note={this.state.notesBank[3]} name={"D#"} classnameDown="blackkey-down" classnameUp="blackkey-up"/>
        </div> 
          <div className="onlywhite">
          <Note handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"C"} keycode={67} note={this.state.notesBank[4]} name={"E"} classnameDown ="whitekey-down" classnameUp="whitekey-up"/>
          </div>
        <div className="blackwhite">
          <Note handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn}  keyb={"V"} keycode={86} note={this.state.notesBank[5]} name={"F"} classnameDown ="_whitekey-down" classnameUp="_whitekey-up" />
          <SharpNote handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"G"} keycode={71} note={this.state.notesBank[6]} name={"F#"} classnameDown="blackkey-down" classnameUp="blackkey-up"/>
        </div>  
        <div className="blackwhite">
          <Note handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"B"} keycode={66} note={this.state.notesBank[7]} name={"G"} classnameDown ="_whitekey-down" classnameUp="_whitekey-up" />
          <SharpNote handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"H"} keycode={72} note={this.state.notesBank[8]} name={"G#"} classnameDown="blackkey-down" classnameUp="blackkey-up"/>
        </div>  
        <div className="blackwhite">
          <Note handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"N"} keycode={78} note={this.state.notesBank[9]} name={"A"} classnameDown ="_whitekey-down" classnameUp="_whitekey-up" />
          <SharpNote handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"J"}keycode={74} note={this.state.notesBank[10]} name={"A#"} classnameDown="blackkey-down" classnameUp="blackkey-up"/>
        </div>  
           <div className="onlywhite">
          <Note handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={"M"} keycode={77} note={this.state.notesBank[11]} name={"B"} classnameDown ="whitekey-down" classnameUp="whitekey-up"/>
          </div>
          <div className="onlywhite">
          <Note handleDisplay = {this.handleDisplay} volume = {this.state.volume} powerBtn = {this.state.powerBtn} keyb={","} keycode={188} note={this.state.notesBank[12]} name={"C2"} classnameDown ="whitekey-down" classnameUp="whitekey-up"/>
          </div>
        </div>
        
       
      </div>
      </Fullscreen>
    )
  }
}